
import React from 'react';
import Logo from './Logo';

interface FooterProps { }

const Footer: React.FC<FooterProps> = () => {
  return (
    <footer className="bg-white py-12 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <Logo size="sm" showText={true} className="hidden sm:flex" />
          <Logo size="sm" showText={false} className="flex sm:hidden" />

          <div className="text-sm text-gray-500">
            © {new Date().getFullYear()} Queenli. All rights reserved.
          </div>

          <div className="flex gap-8 text-sm font-medium text-gray-600">
            <a href="/privacy" className="hover:text-purple-600 transition-colors">Privacy Policy</a>
            <a href="/terms" className="hover:text-purple-600 transition-colors">Creator Terms</a>
            <a href="mailto:contact@torek.io" className="hover:text-purple-600 transition-colors">Contact Us</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
